<template>
  <form class="d-grid gap-3" :action="createActionUrl">
    <component :is="componentForField(field.name)" v-for="field of fieldsToInclude" v-show="shouldShowField(field)"
               v-bind="fieldProps(field)" :key="field.name" entity-name="attendee"
               :validation-errors="validationErrorsForField(field.name)"
               @changed="(value) => updateField(field.name, value, field.isAdditionalField)" />

    <!-- Used on scenarios to check the status of one-click signing -->
    <input type="hidden" name="attendee[one_click_from_crm_status]" :value="oneClickFromCrmStatus">

    <div v-html="disclaimerContent.beforeSubmit" />

    <bot-protected-submit-button ref="submitButton" :label="submitButtonText" :submitting-label="submittingText"
                                 :submit-in-progress="submittingCreateAction" captcha-action="attendee_create"
                                 :validation-errors="validationErrors" button-class="btn btn-primary btn-lg w-100"
                                 @submit="submit" />

    <div v-if="showDataProcessingConsentAfterSubmit" class="small-text mt-2" v-html="dataProcessingConsentLabel" />

    <div v-html="disclaimerContent.afterSubmit" />
  </form>
</template>

<script>
import FormMixin from '@/campaign-action-shared/form-mixin'
import { mapGetters, mapState } from 'vuex'
import ShiftsField from './shifts-field'
import { WAITING_LIST } from './attending-statuses'

export default {
  components: { ShiftsField },

  mixins: [ FormMixin ],

  props: {
    attendingStatus: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapGetters(['dataProcessingConsentLabel', 'showDataProcessingConsentAfterSubmit']),
    ...mapState(['disclaimerContent', 'oneClickFromCrmStatus', 'retryingSubmit']),

    entityType() {
      return 'attendee'
    },

    submitButtonText() {
      if (this.attendingStatus === WAITING_LIST) {
        return this.i18n.t('buttons.join_waiting_list')
      } else {
        return this.i18n.t('buttons.i_am_going')
      }
    },

    submittingText() {
      if (this.attendingStatus === WAITING_LIST) {
        return this.i18n.t('buttons.joining_waiting_list')
      } else {
        return this.i18n.t('buttons.joining_event')
      }
    }
  },

  watch: {
    retryingSubmit() {
      if (this.retryingSubmit) {
        this.$refs.submitButton.recalculateAndResubmit()
      }
    }
  },

  methods: {
    componentForField(fieldName) {
      if (fieldName === 'shifts') {
        return ShiftsField
      } else {
        return this.componentForCommonField(fieldName)
      }
    },

    extraPropsForField(fieldConfig) {
      switch (fieldConfig.name) {
      case 'shifts':
        return {
          shifts: fieldConfig.shifts,
          showDaysForShifts: fieldConfig.showDayHeaders
        }
      default:
        return this.extraPropsForCommonField(fieldConfig)
      }
    },

    submit({friendlyCaptchaSolution, hcaptchaResponse, recaptchaToken, turnstileToken}) {
      this.$store.dispatch('saveNewAction', {attendingStatus: this.attendingStatus, friendlyCaptchaSolution, hcaptchaResponse, recaptchaToken, turnstileToken})
    },

    updateField(fieldName, value, isAdditionalField) {
      if (fieldName === 'shifts') {
        this.setFieldValue({field: 'shiftIds', value})
      } else {
        this.updateCommonField({fieldName, value, isAdditionalField})
      }
    }
  }
}
</script>
